import BaseApi from '../BaseApi';
import { CashbackConverter } from './CashbackConverter';

class CashbackApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/agent_admin`;
    this.converter = new CashbackConverter();
  }

  createCashback = data => this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/cashback/rules`, data);

  getCashbackList = params =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}/cashback/rules/list`,
      params,
      null,
      this.converter.convertCashbackList,
    );

  deleteCashback = ({ id }) => this.sendQuery(this.queryTypes.DELETE, `${this.baseUrl}/cashback/rules/${id}`);
}

export default CashbackApi;
